import { GridApi, RowNode, RangeSelection, Column, ColumnApi } from "ag-grid";
import { AgGridNg2 } from "ag-grid-angular";

export class AgEvent {
  
  static onDelKeyDown(event: KeyboardEvent, grid: AgGridNg2) {
    if (!(event.keyCode == 46 || event.keyCode == 8)) return;
    grid.api.stopEditing();
    let api: GridApi = grid.api;
    let ranges: RangeSelection[] = api.getRangeSelections();
    if (!ranges || ranges.length <= 0) return;
    
    // console.log(grid);
    // console.log(grid.api.getRangeSelections());
    // console.log(grid.api.getSelectedNodes());
    
    // let data = grid.rowData;
    ranges.forEach(range => {
        let startIdx: number = range.start.rowIndex;
        let endIdx: number = range.end.rowIndex;
        let cols: Column[] = range.columns;
        
        api.forEachNode(node => {
          if (node.rowIndex >= startIdx && node.rowIndex <= endIdx){
            let rowData = node.data;
            cols.forEach(col => {
              if (!col.isCellEditable(node)) return;
              if (event.keyCode == 46 || event.keyCode == 8) {
                rowData[col.getColDef().field] = null;
                node.setData(rowData);
              }
            });
          }
        });
      }
    );
  }

  
}


// WEBPACK FOOTER //
// ./src/app/components/ag-grid/ag-event.ts